export enum WarningPreferenceType {
  HypoglycemiaAlert = 1,
  GlucoseMeasurementMissed = 2,
  SurveyDataMissing = 3,
}
